import { MDBCol, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom";
import axiosGet from "../../helpers/axiosGet";
import "./outstanding.css";
import { useDispatch, useSelector } from "react-redux";
import {
  resetOutstandingInvoice,
  setDataSearchOutstandingInvoice,
} from "../../store/outstanding/actions";
import constants from "../../constants";
import Loading from "../../components/Loading";

export default function Outstanding() {
  let { uniqId } = useParams();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [outstandingData, setOutstandingData] = useState([]);
  const [fileId, setFileId] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const signature = params.get("signature");
  const dataSearchOutstandingInvoice = useSelector(
    (state) => state.outstanding.dataSearchOutstandingInvoice
  );
  const [filterInvoiceNumber, setFilterInvoiceNumber] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limitData, setLimitData] = useState(1);

  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    axiosGet({
      url: `${constants.GATEWAY_URL}/back-office/outstanding/invoice/${uniqId}/page/${dataSearchOutstandingInvoice.storedPage}?invoiceNumber=${dataSearchOutstandingInvoice.storedValues.invoiceNumber}`,
      headers: {
        "X-Open-Signature": signature,
      },
      callback: (res) => {
        setLoading(false);
        setOutstandingData(res.data.data);
        setTotalPage(res.data.totalPage);
        setCurrentPage(res.data.page);
        setLimitData(res.data.limit);
      },
      errorCallback: (err) => {
        setLoading(false);
        setError(err);
        console.log(err);
      },
    });
  }, [
    signature,
    uniqId,
    dataSearchOutstandingInvoice.storedPage,
    dataSearchOutstandingInvoice.storedValues.invoiceNumber,
  ]);

  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadLoadingZip, setDownloadLoadingZip] = useState(false);

  const handleDownload = (id, invNumber) => {
    setDownloadLoading(true);

    axiosGet({
      url: `${constants.GATEWAY_URL}/back-office/outstanding/download-invoice/${id}`,
      headers: {
        "X-Open-Signature": signature,
      },
      responseType: "blob",
      callback: (res) => {
        console.log(res);
        setDownloadLoading(false);
      },
      errorCallback: (res) => {
        setDownloadLoading(false);

        const blob = new Blob([res]);
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", `${invNumber}-Invoice.pdf`);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
    });
  };

  const handleFilterChange = (e) => {
    setFilterInvoiceNumber(e.target.value);
  };

  const handlePage = (e, value) => {
    e.preventDefault();

    dispatch(
      setDataSearchOutstandingInvoice({
        ...dataSearchOutstandingInvoice,
        storedPage: value,
      })
    );
  };

  const handleSubmitFilter = () => {
    console.log(filterInvoiceNumber);
    dispatch(
      setDataSearchOutstandingInvoice({
        storedValues: {
          invoiceNumber: filterInvoiceNumber,
        },
        storedPage: 1,
      })
    );
  };

  const handleResetFilter = () => {
    setFilterInvoiceNumber("");
    dispatch(resetOutstandingInvoice());
  };

  const handleDownloadZip = () => {
  setDownloadLoadingZip(true);

  axiosGet({
    url: `${constants.GATEWAY_URL}/back-office/outstanding/download-zip/${uniqId}`,
    headers: {
      "X-Open-Signature": signature,
    },
    callback: (res) => {
      setDownloadLoadingZip(false);
      const { url } = res.data || {};
      if (!url) return;

      const a = document.createElement("a");
      a.href = url;
      try {
        const pathname = new URL(url).pathname;
        const suggestedName =
          decodeURIComponent(pathname.split("/").pop() || "Invoice.zip");
        a.setAttribute("download", suggestedName);
      } catch (_) {
        a.setAttribute("download", "Invoice.zip");
      }
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    errorCallback: (err) => {
      setDownloadLoadingZip(false);
      console.error("Failed to get ZIP URL", err);
    },
  });
};

  return (
    <>
      {loading ? (
        <div className="vh-100 d-flex align-items-center justify-content-center">
          <Loading />
        </div>
      ) : error && error?.statusCode === 403 ? (
        <div
          className="mt-5 mb-5 d-flex justify-content-center align-items-center"
          style={{ minHeight: "200px" }}
        >
          <p className="text-center text-danger">
            The link has already expired. <br />
            If you need to access the data, please don't hesitate to contact our finance team at {" "}
            <a
              href="https://api.whatsapp.com/send/?phone=6285157882496"
              target="_blank"
              rel="noreferrer"
            >
              <span>(+62 851-5788-2496)</span>
            </a>{" "}
          </p>
        </div>
      ) : (
        <>
          <div className="mt-5">
            <p className="link-text">Outstanding Invoice Detail</p>
            <hr className="divider" />
          </div>
          <div className="mt-5">
            <MDBRow className="create-row-gap">
              <MDBCol md="12">
                <div className="card-table p-10">
                  <div className="mb-4 text-right d-flex align-items-center justify-content-between">
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px", maxWidth: "450px" }}
                    >
                      <input
                        type="text"
                        placeholder="Search Invoice Number"
                        className="form-control custom-input"
                        value={filterInvoiceNumber}
                        onChange={handleFilterChange}
                        style={{ maxWidth: "300px" }}
                      />
                      <button
                        className="submit-button"
                        onClick={handleSubmitFilter}
                      >
                        Submit
                      </button>
                      <button
                        className="reset-button"
                        onClick={handleResetFilter}
                      >
                        Reset
                      </button>
                    </div>
                    <button
                      className="zip-download-button"
                      onClick={handleDownloadZip}
                    >
                      {downloadLoadingZip ? (
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <span>Download ZIP</span>
                      )}
                    </button>
                  </div>
                  <MDBTable hover bordered responsive>
                    <MDBTableHead>
                      <tr>
                        <th>#</th>
                        <th>Invoice Number</th>
                        <th>Action</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {outstandingData.length > 0 ? (
                        outstandingData.map((item, index) => (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * limitData + index + 1}</td>
                            <td>{item.invoiceNumber}</td>
                            <td>
                              <button
                                className="download-action"
                                onClick={() => {
                                  handleDownload(
                                    item.fileId,
                                    item.invoiceNumber
                                  );
                                  setFileId(item.fileId);
                                }}
                                disabled={downloadLoading && fileId === item.fileId}
                              >
                                {downloadLoading && fileId === item.fileId ? (
                                  <div
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  <span>Download</span>
                                )}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No data
                          </td>
                        </tr>
                      )}
                    </MDBTableBody>
                  </MDBTable>

                  {outstandingData.length > 0 && (
                    <Pagination
                      currentPage={currentPage}
                      totalPage={totalPage}
                      handlePage={handlePage}
                    />
                  )}
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </>
      )}
    </>
  );
}

const Pagination = ({ currentPage, totalPage, handlePage }) => {
  const pageNumbers = [];
  const maxVisiblePages = 5;

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPage, startPage + maxVisiblePages - 1);

  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination justify-content-end">
        {/* <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={(e) => handlePage(e, 1)}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>
        </li> */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={(e) => handlePage(e, currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lsaquo;
          </button>
        </li>

        {startPage > 1 && (
          <li className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        )}

        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${currentPage === number ? "active" : ""}`}
          >
            <button
              className="page-link"
              onClick={(e) => handlePage(e, number)}
            >
              {number}
            </button>
          </li>
        ))}

        {endPage < totalPage && (
          <li className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        )}

        <li
          className={`page-item ${currentPage === totalPage ? "disabled" : ""}`}
        >
          <button
            className="page-link"
            onClick={(e) => handlePage(e, currentPage + 1)}
            disabled={currentPage === totalPage}
          >
            &rsaquo;
          </button>
        </li>
        {/* <li
          className={`page-item ${currentPage === totalPage ? "disabled" : ""}`}
        >
          <button
            className="page-link"
            onClick={(e) => handlePage(e, totalPage)}
            disabled={currentPage === totalPage}
          >
            &raquo;
          </button>
        </li> */}
      </ul>
    </nav>
  );
};
